<template>
  <section class="update-health-status-container">
    <div class="container">
      <header class="row">
        <div class="col-xs-12 ml- p-2">
          <router-link :to="{ name: 'HealthStatusPage' }" class="back-button">
            <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
          </router-link>
        </div>
      </header>
      <section class="mt-2">
        <h5 class="text-center">Health Status</h5>
        <!-- Not a huge fan of this... but it's whatever -->
        <!-- Also this is only designed as if it's a multiple choice right now -->
        <!-- Question 1 -->
        <health-status-view-item class="health-view-container" :current-page="currentPage" v-if="currentPage === 1">
          <p class="health-status-question mb-2 p-0">{{ this.completables[0].question.en }}</p>
          <div class="custom-control custom-radio mb-1 py-2">
            <input type="radio" id="more-symptom" name="customRadio" class="custom-control-input" :value="true" v-model="completables[0].answers[0].selected">
            <label class="custom-control-label" for="more-symptom">I have one or more COVID-19 symptoms, or I have tested positive for COVID-19 in the past 10 days.</label>
          </div>
          <div class="custom-control custom-radio mb-1 py-2">
            <input type="radio" id="free-symptom" name="customRadio" class="custom-control-input" :value="true" v-model="completables[0].answers[1].selected">
            <label class="custom-control-label" for="free-symptom">I am symptom free, and I have not tested positive for COVID-19 in the past 10 days.</label>
          </div>
          <base-card class="card-info p-3">
            <h5 class="card-title">COVID-19 Symptoms</h5>
            <!-- <div class="rendered-info" v-html="renderMarkdown(this.completables[0].body.en)"></div> -->
            <div class="rendered-info">
              <p>People with COVID-19 have had a wide range of symptoms reported – ranging from mild symptoms to severe illness. These symptoms may appear 2-14 days after exposure to the virus:</p>
              <ul>
                <li>Fever (100.4°F/38°C or higher)</li>

                <li>Chills</li>

                <li>Cough</li>

                <li>Shortness of breath or difficulty breathing</li>

                <li>Fatigue</li>

                <li>Muscle or body aches</li>

                <li>Headache</li>

                <li>New loss of taste or smell</li>

                <li>Sore throat</li>

                <li>Congestion or runny nose</li>

                <li>Nausea or vomiting</li>

                <li>Diarrhea</li>
              </ul>
            </div>
          </base-card>
        </health-status-view-item>
        <!-- Question 2 -->
        <health-status-view-item class="health-view-container" :current-page="currentPage" v-else-if="currentPage === 2">
          <p class="health-status-question mb-2 p-0">{{ this.completables[1].question.en }}</p>
          <div class="custom-control custom-radio mb-1 py-2">
            <input type="radio" id="in-contact" name="customRadio" class="custom-control-input" :value="true" v-model="completables[1].answers[0].selected">
            <label class="custom-control-label" for="in-contact">I have been in contact with someone who has COVID-19 or COVID-19 symptoms and I am not fully vaccinated.</label>
          </div>
          <div class="custom-control custom-radio mb-1 py-2">
            <input type="radio" id="no-contact" name="customRadio" class="custom-control-input" :value="true" v-model="completables[1].answers[1].selected">
            <label class="custom-control-label" for="no-contact">I have not been in contact with someone who has COVID-19 or COVID-19 symptoms, OR other considerations allow me to continue to work.</label>
          </div>
          <base-card class="card-info p-3">
            <h5 class="card-title">OTHER CONSIDERATIONS:</h5>
            <div class="rendered-info">
              <ul>
                <li>I am a medical worker and have contact with COVID-19 patients as part of my job.</li>
                <li>I have discussed my potential COVID-19 contact with my employer and have received permission to return to work.</li>
                <li>I am fully vaccinated (i.e., ≥2 weeks following receipt of the final dose) and have remained asymptomatic since the current COVID-19 exposure.</li>
                <li>I can show documentation of recovery from COVID-19 in the past 3 months.</li>
              </ul>
            </div>
          </base-card>
        </health-status-view-item>
        <!-- Question 3 -->
        <health-status-view-item class="health-view-container" :current-page="currentPage" v-else-if="currentPage === 3">
          <p class="health-status-question mb-2 p-0" v-html="renderMarkdown(this.completables[2].question.en)"></p>
          <div class="custom-control custom-radio mb-1 py-2">
            <input type="radio" id="multiple-risk" name="customRadio" class="custom-control-input" :value="true" v-model="completables[2].answers[0].selected">
            <label class="custom-control-label" for="multiple-risk">I have, or may have, traveled internationally or to a high-risk destination and I am not fully vaccinated.</label>
          </div>
          <div class="custom-control custom-radio mb-1 py-2">
            <input type="radio" id="no-risk" name="customRadio" class="custom-control-input" :value="true" v-model="completables[2].answers[1].selected">
            <label class="custom-control-label" for="no-risk">I have not traveled internationally or to a high-risk destination OR other considerations allow me to work.</label>
          </div>
          <base-card class="card-info p-3" v-if="this.completables[2].body.en">
            <h5 class="card-title">COVID-19 Risk Factors </h5>
            <div class="rendered-info" v-html="renderMarkdown(this.completables[2].body.en)"></div>
          </base-card>
          <base-card class="card-info p-3">
            <h5 class="card-title">OTHER CONSIDERATIONS:</h5>
            <div class="rendered-info">
              <ul>
                <li>I have spoken to my employer about my travel and have received permission to return to work.</li>
                <li>I am fully vaccinated (i.e., ≥2 weeks following receipt of the final dose) and have remained asymptomatic since my return.</li>
                <li>I have received a negative COVID-19 test 3-5 days after my return.</li>
                <li>I can show documentation of recovery from COVID-19 in the past 3 months.</li>
              </ul>
            </div>
          </base-card>
        </health-status-view-item>
        <!-- Final submission --->
        <health-status-view-item class="health-view-container" :current-page="currentPage" v-else>
          <p class="health-status-question mb-2 p-0">Your health status responses are: </p>
          <ul class="selected-answers-list">
            <template v-for="(complete, index) in completables">
              <template v-for="(answer, idx) in complete.answers">
                <li v-if="answer.selected === true" :key="`submission-ans-${index}-${idx}`" class="answer-list-item p-2">
                  <div v-if="answer.value === 1" class="correct-answer">
                    <font-awesome-icon :icon="['fas', 'check-circle']" class="icon"></font-awesome-icon> {{ answer.body.en }}
                  </div>
                  <div class="wrong-answer p-2" v-else>
                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="icon"></font-awesome-icon> {{ answer.body.en }}
                  </div>
                </li>
              </template>
            </template>
          </ul>
          <template v-if="loading">
            <div class="loader">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </template>

          <button class="btn btn-block health-submit-btn mx-auto" @click="submitHealthStatus">{{ $t('healthStatus.submitHealthStatus') }}</button>
          <base-card class="card-info mt-2 p-3">
            <p class="rendered-info">
              {{ $t('healthStatus.submitHealthStatusDisclaimer') }}
            </p>
          </base-card>
        </health-status-view-item>
      </section>
    </div>
    <!-- Let's setup some of the modals here. again not a fan. If someone wants to take a stab at componentizing at this please be my guest -->
    <!-- Question 1 bad health check popup -->
    <base-modal :id="'symptoms'">
      <h5 class="health-modal-subtitle">{{ $t('healthStatus.tabs.title') }}</h5>
      <h3 class="health-modal-title m-0">{{ $t('healthStatus.tabs.firstTab.title') }}</h3>
      <p class="health-modal-disclaimer mb-2">{{ $t('healthStatus.tabs.disclaimer') }}</p>
      <ul class="health-modal-list">
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'user-md-chat']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.firstTab.info.firstPoint') }}
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'house-user']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.firstTab.info.secondPoint') }}
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'file-medical']" class="icon mr-2"></font-awesome-icon>
          <i18n path="healthStatus.tabs.firstTab.info.thirdPoint" for="healthStatus.tabs.firstTab.link">
            <a href="https://www.cdc.gov/coronavirus/2019-ncov/downloads/10Things.pdf" target="_blank" style="color: rgb(0, 106, 158); text-decoration: underline">{{ $t('healthStatus.tabs.firstTab.link') }}</a>
          </i18n>
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'comment-alt-edit']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.firstTab.info.fourthPoint') }}
        </li>
      </ul>
      <div class="health-card">
        <p class="card-title p-2">{{ $t('healthStatus.tabs.firstTab.warning.title') }}</p>
        <ul class="rendered-info pl-2 ml-3">
          <li>{{ $t('healthStatus.tabs.firstTab.warning.firstPoint') }}</li>
          <li>{{ $t('healthStatus.tabs.firstTab.warning.secondPoint') }}</li>
          <li>{{ $t('healthStatus.tabs.firstTab.warning.thirdPoint') }}</li>
          <li>{{ $t('healthStatus.tabs.firstTab.warning.fourthPoint') }}</li>
          <li>{{ $t('healthStatus.tabs.firstTab.warning.fifthPoint') }}</li>
        </ul>
      </div>
    </base-modal>
    <!-- Question 2 bad health check popup -->
    <base-modal :id="'contact'">
      <h5 class="health-modal-subtitle">{{ $t('healthStatus.tabs.title') }}</h5>
      <h3 class="health-modal-title m-0">{{ $t('healthStatus.tabs.secondTab.title') }}</h3>
      <p class="health-modal-disclaimer mb-2">{{ $t('healthStatus.tabs.disclaimer') }}</p>
      <ul class="health-modal-list">
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'house-user']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.secondTab.info.firstPoint') }}
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'laptop-house']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.secondTab.info.secondPoint') }}
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'notes-medical']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.secondTab.info.thirdPoint') }}
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'user-shield']" class="icon mr-2"></font-awesome-icon>
          <i18n path="healthStatus.tabs.secondTab.info.fourthPoint" for="healthStatus.tabs.secondTab.link">
            <a href="https://www.cdc.gov/coronavirus/2019-ncov/need-extra-precautions/people-at-increased-risk.html" target="_blank" style="color: rgb(0, 106, 158); text-decoration: underline">{{ $t('healthStatus.tabs.secondTab.link') }}</a>
          </i18n>
        </li>
      </ul>
      <div class="health-card">
        <p class="card-title p-2">{{ $t('healthStatus.tabs.secondTab.warning.title') }}</p>
      </div>
    </base-modal>
    <!-- Question 3 bad health check popup -->
    <base-modal :id="'risk-factor'">
      <h5 class="health-modal-subtitle">{{ $t('healthStatus.tabs.title') }}</h5>
      <h3 class="health-modal-title m-0">{{ $t('healthStatus.tabs.thirdTab.title') }}</h3>
      <p class="health-modal-disclaimer mb-2">{{ $t('healthStatus.tabs.disclaimer') }}</p>
      <ul class="health-modal-list">
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'house-user']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.secondTab.info.firstPoint') }}
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'laptop-house']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.secondTab.info.secondPoint') }}
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'notes-medical']" class="icon mr-1"></font-awesome-icon> {{ $t('healthStatus.tabs.secondTab.info.thirdPoint') }}
        </li>
        <li class="p-3">
          <font-awesome-icon :icon="['fal', 'user-shield']" class="icon mr-2"></font-awesome-icon>
          <i18n path="healthStatus.tabs.secondTab.info.fourthPoint" for="healthStatus.tabs.secondTab.link">
            <a href="https://www.cdc.gov/coronavirus/2019-ncov/need-extra-precautions/people-at-increased-risk.html" target="_blank" style="color: rgb(0, 106, 158); text-decoration: underline">{{ $t('healthStatus.tabs.secondTab.link') }}</a>
          </i18n>
        </li>
      </ul>
      <div class="health-card">
        <p class="card-title p-2">{{ $t('healthStatus.tabs.secondTab.warning.title') }}</p>
      </div>
    </base-modal>
  </section>
</template>

<script>
import marked from 'marked';
import DOMPurify from 'dompurify';
import { mapActions, mapState, mapMutations } from 'vuex';
import common from "@/mixins/common";
import SubmissionService from '@/services/submission.service';
import MemberService from '@/services/member.service';
import honeybadger from "@/mixins/honeybadger";

export default {
  name: 'UpdateHealthStatus',
  mixins: [common, honeybadger],
  components: {
    HealthStatusViewItem: () => import('@/components/health-status-view-item/health-status-view-item.vue'),
    BaseCard: () => import('@/components/base-card/base-card.vue'),
    BaseModal: () => import('@/components/base-modal/base-modal.vue'),
  },
  data() {
    return {
      completables: [
        {
          answers: [
            {
              body: {
                en: 'I have one or more COVID-19 symptoms, or I have tested positive for COVID-19 in the past 10 days.',
              },
              selected: false,
              value: 0,
            },
            {
              body: {
                en: 'I am symptom free, and I have not tested positive for COVID-19 in the past 10 days.',
              },
              selected: false,
              value: 1,
            },
          ],
          type: 'multiple_choice',
          weight: 1,
          question: {
            en: 'Are you experiencing one or more COVID-19 symptoms from the list below, or have you tested positive for COVID-19 in the past 10 days?',
          },
          body: {
            en: 'People with COVID-19 have had a wide range of symptoms reported – ranging from mild symptoms to severe illness. These symptoms may appear 2-14 days after exposure to the virus: \n\n- Fever (100.4°F/38°C or higher) \n\n- Chills \n\n- Cough \n\n- Shortness of breath or difficulty breathing \n\n- Fatigue \n\n- Muscle or body aches \n\n- Headache \n\n- New loss of taste or smell \n\n- Sore throat \n\n- Congestion or runny nose \n\n- Nausea or vomiting \n\n- Diarrhea',
          },
          question_uid: '865e8812-49de-4f12-b5c0-35e2056c677f',
        },
        {
          answers: [
            {
              body: {
                en: 'I have been in contact with someone who has COVID-19 or COVID-19 symptoms and I am not fully vaccinated.',
              },
              selected: false,
              value: 0,
            },
            {
              body: {
                en: 'I have not been in contact with someone who has COVID-19 or COVID-19 symptoms, OR other considerations allow me to continue to work.',
              },
              selected: false,
              value: 1,
            },
          ],
          type: 'multiple_choice',
          weight: 1,
          question: {
            en: 'Have you been in contact with someone who has COVID-19 or COVID-19 symptoms in the past 14 days?',
          },
          body: {
            en: '',
          },
          question_uid: 'b494dd8a-4cd7-4a7f-b519-6a253e59fb66',
        },
        {
          answers: [
            {
              body: {
                en: 'I have, or may have, traveled internationally or to a high-risk destination and I am not fully vaccinated.',
              },
              selected: false,
              value: 0,
            },
            {
              body: {
                en: 'I have not traveled internationally or to a high-risk destination OR other considerations allow me to work.',
              },
              selected: false,
              value: 1,
            },
          ],
          type: 'multiple_choice',
          weight: 1,
          question: {
            en: 'Have you traveled internationally or to a COVID-19 high-risk destination (<a href="https://www.cdc.gov/coronavirus/2019-ncov/travelers/index.html" style="color: rgb(0, 106, 158); text-decoration: underline" target="_blank">level 3 or level 4 per the CDC</a>) in the past 14 days?',
          },
          body: {
            en: '',
          },
          question_uid: 'fcc1815a-ba83-4e65-b2ee-cf89b5294609',
        },
      ],
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    ...mapState(['defaultOrganization', 'currentMember', 'currentHealthStatus', 'currentHealthStatusActivity']),
    firstSurveyQuestion() {
      return this.completables[0];
    },
    secondSurveyQuestion() {
      return this.completables[1];
    },
    thirdSurveyQuestion() {
      return this.completables[2];
    },
  },
  mounted() {
    this.initialLoad();
  },
  methods: {
    ...mapActions([
      'getCurrentHealthCheck',
    ]),
    ...mapMutations(['setCurrentHealthStatus', 'setCurrentMember']),
    reset() {
    },
    initialLoad() {
      this.reset();
      this.log('UpdateHealthStatus -> initialLoad', 'currentHealthStatusActivity', this.currentHealthStatusActivity);
      if (this.currentHealthStatus === null) {
        this.getCurrentHealthCheck();
      }
    },
    renderMarkdown(source) {
      return DOMPurify.sanitize(marked(source), { ADD_ATTR: ['target'] });
    },
    submitHealthStatus() {
      this.loading = true;
      let memberId = this.currentMember.id;
      const activityId = this.currentHealthStatusActivity.id;
      const params = {
        data: { completables: this.completables },
        member_id: memberId,
        activity_id: activityId,
      };
      this.addHoneyBadgerContext(params);
      SubmissionService.create(params).then(({ data }) => {
        this.log('UpdateHealthStatus -> submitHealthStatus -> SubmissionService.create', 'data', data);
        let newHealthData = data;
        this.setCurrentHealthStatus(newHealthData);
        this.successGrowl('Submitted Health Status');
        return MemberService.show(memberId);
      }).then(({ data }) => {
        this.log('UpdateHealthStatus -> submitHealthStatus -> MemberService.show', 'data', data);
        this.setCurrentMember(data);
        this.loading = false;
        this.clearHoneyBadgerContext();
        this.safelyNavigateToPath('HealthStatusPage');
      });
    },
  },
  watch: {
    firstSurveyQuestion: {
      deep: true,
      handler(newVal) {
        if (newVal.answers[0].selected === true) {
          this.openModal('symptoms');
        }
        const self = this;
        setTimeout(() => {
          self.currentPage += 1;
        }, 200);
      },
    },
    secondSurveyQuestion: {
      deep: true,
      handler(newVal) {
        if (newVal.answers[0].selected === true) {
          this.openModal('contact');
        }
        const self = this;
        setTimeout(() => {
          self.currentPage += 1;
        }, 200);
      },
    },
    thirdSurveyQuestion: {
      deep: true,
      handler(newVal) {
        if (newVal.answers[0].selected === true) {
          this.openModal('risk-factor');
        }
        const self = this;
        setTimeout(() => {
          self.currentPage += 1;
        }, 200);
      },
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">

</style>
